// extracted by mini-css-extract-plugin
export default {"container":"styles_container__d6vn2","submit":"styles_submit__fO66H","subtitle":"styles_subtitle__QluPk"};